import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import { DatePickerWithLabel } from 'commons/DatePicker/DatePickerWithLabel';
import { SimpleText } from 'commons/SimpleText/SimpleText';
import { TextFieldWithLabel } from 'commons/TextFieldWithLabel/TextFieldWithLabel';
import SkeletonLaboratoryGrid from 'components/Skeletons/SkeleronLaboratoryGrid/SkeletonLaboratoryGrid';
import React from 'react';
import { timestampToDate } from 'utils/processing/dates';
import {
  CONTRACT_STATUS,
  PRODUCT_TEST_TYPE,
  RECOVER_UNIT_POSSIBILITY
} from "components/ProductTest/ProductTestProjection";
import { localize } from "commons/LocalizedText/LocalizedText";


const useStyles = makeStyles((theme) => ({
  container: {
    padding: '50px 0'
  },
  countryAutoComplete: {
    minWidth: '300px',
    margin: 0,
    '& .MuiTextField-root': {
      marginTop: 0
    }
  },
  generalPadding: {
    marginTop: theme.spacing(5)
  }
}));


export const ProductTestGeneralPage = ({ changedFields, productTestGeneral, onChange, isLoadingTestDetails }) => {
  const classes = useStyles();
  const colorProductType = productTestGeneral?.productTestType?.ptTypeId === PRODUCT_TEST_TYPE.ADMISSION_TEST ? 'red' : 'black';
  const colorCustomerStatus = productTestGeneral?.customerType?.statusId === CONTRACT_STATUS.APPLICANT ? 'red' : 'black';
  const colorRecoverUnit = productTestGeneral?.recoverUnit?.valueId === RECOVER_UNIT_POSSIBILITY.YES ? 'green' : 'black';

  return (
    !isLoadingTestDetails ?
      <div className={classes.generalPadding}>
        <Grid container direction='row' justifyContent="space-evenly" spacing={1}>
          <Grid item xs={6}>
            <Grid container direction='column' spacing={1}>
              <SimpleText
                label='referenceYear'
                value={productTestGeneral?.referenceYear}
              />
              <SimpleText
                label='program'
                value={productTestGeneral?.programName}
              />
              <SimpleText
                label='subProgram'
                value={productTestGeneral?.subProgram}
              />
              <SimpleText
                label='eccTestNumber'
                value={productTestGeneral?.eccTestNumber}
              />
              <SimpleText
                color={colorProductType}
                label='testType'
                value={productTestGeneral?.productTestType?.ptTypeTranslated}
              />
              <SimpleText
                color={colorCustomerStatus}
                label='customerStatus'
                value={productTestGeneral?.customerType?.statusTranslated}
              />
              <SimpleText
                label='testStatus'
                value={productTestGeneral?.testStatus?.ptldStatusTrad}
              />
              <SimpleText
                color={colorRecoverUnit}
                label='recoverUnit'
                value={productTestGeneral?.recoverUnit?.possibilityTranslated}
              />
              <SimpleText
                label='scrapping'
                value={productTestGeneral?.scrappingRequested ? localize('yes'): localize('no')}
              />
            </Grid>
          </Grid>
          <Grid item xs={6}>
            <Grid container direction='column' spacing={1}>
              <TextFieldWithLabel
                enableColorChangeOnModification
                label='laboratoryTestNumber'
                onChange={value => onChange(value, ['laboratoryTestNumber'])}
                startsModified={changedFields.includes('laboratoryTestNumber')}
                value={productTestGeneral?.laboratoryTestNumber}
              />
              <DatePickerWithLabel
                enableColorChangeOnModification
                label='scheduledTestDate'
                onChange={value => onChange(value, ['scheduledTestDate'])}
                startsModified={changedFields.includes('scheduledTestDate')}
                value={productTestGeneral?.scheduledTestDate}
              />
              <DatePickerWithLabel
                enableColorChangeOnModification
                label='testDate'
                onChange={value => onChange(value, ['testDate'])}
                startsModified={changedFields.includes('testDate')}
                value={productTestGeneral?.testDate}
              />
              <SimpleText
                label='deliveryDeadline'
                value={timestampToDate(productTestGeneral?.deliveryDeadline) || ''}
              />
            </Grid>
          </Grid>
        </Grid>
      </div>
      :
      <SkeletonLaboratoryGrid className={classes.container} />
  );
};